import React from "react";
// Components
import RowTools from "../../../../../components/Table/RowTools";

const columns = ({ showEditModal, deleteRow, editable, showMapModal,showViewModal } = {}) =>{
  var cl = [
    {
      // key: "Id",
      title: "#",
      dataIndex: "stt",
      width: "55px"
    },
    {
      // key: "",
      title: "Tên trạm",
      dataIndex: "tenTram",
      render: (value, row) => <span className="row-name" onClick={() => showViewModal(row, "view")}>{value}</span>,
    },
    {
      // key: "",
      title: "Địa điểm trạm",
      dataIndex: "diaDiem",
      width: "20%"
    },
    {
      key: "tools",
      title: "Thao tác",
      dataIndex: "tools",
      align: "center",
      width: "80px",
      render: (value, row) => (
        <RowTools 
        row={row} 
        iconDelete={editable ? false : true} 
        iconEdit={editable ? false : true} 
        showEditModal={showEditModal} 
        deleteRowModal={deleteRow} 
        iconMap={false} 
        showMapModal={showMapModal}/>
      )
    }
  ];
return cl.map(col => ({
  ...col,
}));
};

export default columns;
